import { useState } from "react";
import styles from "../style/termsOfUse.module.css";
import Features from "../components/features/Features";
import { companyName } from "../Const";

const SECTIONS = [
    {
        id: 1,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
            </svg>
        ),
        title: "Acceptance of Terms",
        summary: `By using ${companyName}, you confirm acceptance of these Terms.`,
        content: `By using ${companyName}, you confirm that you accept these Terms of Use and agree to follow all applicable laws and regulations. If you do not agree with any part of these terms, you may not use our platform.`,
    },
    {
        id: 2,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 1l3 6 6 .9-4.5 4.4 1 6.2L12 16l-5.5 2.5 1-6.2L3 7.9 9 7z" />
            </svg>
        ),
        title: `About ${companyName}`,
        summary: `${companyName} is a real estate platform connecting all stakeholders.`,
        content: `${companyName} is a real estate platform that connects buyers, sellers, investors, brokers, agents, and property seekers with verified property listings and services. Our mission is to make property discovery smarter and more transparent.`,
    },
    {
        id: 3,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 21a8 8 0 0 0-16 0" />
                <circle cx="12" cy="7" r="4" />
            </svg>
        ),
        title: "User Accounts",
        summary: "You are responsible for the confidentiality of your account.",
        content: "You are responsible for maintaining the confidentiality of your account credentials and for all activities conducted under your account. Notify us immediately of any unauthorised use. We reserve the right to disable accounts at our discretion.",
    },
    {
        id: 4,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 10l9-7 9 7" />
                <path d="M5 10v10h14V10" />
            </svg>
        ),
        title: "Property Listings",
        summary: "All property information must be accurate and lawful.",
        content: `Users are responsible for ensuring that all property information is accurate, lawful, and not misleading. ${companyName} reserves the right to remove listings that violate these standards. False or duplicate listings may result in account suspension.`,
    },
    {
        id: 5,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="4" y1="20" x2="20" y2="4" />
            </svg>
        ),
        title: "Lead Generation & Communications",
        summary: "Lead Tracks simplifies communication between users and advertisers.",
        content: <>
        <p>Lead Tracks provides inquiry forms, messaging tools, call requests, and communication systems to facilitate interaction between users and advertisers.</p>
        <p>Users acknowledge that:</p>
        <ul>
            <li>Lead quality is not guaranteed</li>
            <li>Responses depend on third-party brokers or agencies</li>
            <li>Communication may be monitored for quality and security purposes</li>
            <li>Inquiry information may be shared with relevant advertisers</li>
        </ul>
        <p>Users must not misuse communication tools for spam, harassment, or unauthorized marketing.</p>
        </>,
    },
    {
        id: 6,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="4" y1="20" x2="20" y2="4" />
            </svg>
        ),
        title: "Broker & Agency Responsibilities",
        summary: "Registered brokers and agencies must",
        content: <>
        <p>Registered brokers and agencies must:</p>
        <ul>
            <li>Hold valid real estate licenses where required</li>
            <li>Follow local property regulations</li>
            <li>Maintain accurate listing information</li>
            <li>Conduct business ethically and transparently</li>
        </ul>
        <p>Lead Tracks may request verification documents including:</p>
        <ul>
            <li>Brokerage Licenses</li>
            <li>Agency Registration Documents</li>
            <li>Government Identification</li>
            <li>RERA Certifications</li>
        </ul>
        <p>Failure to comply may result in account suspension.</p>
        </>,
    },
    {
        id: 7,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="4" y1="20" x2="20" y2="4" />
            </svg>
        ),
        title: "Prohibited Activities",
        summary: "No false listings, impersonation, or illegal activities.",
        content: "You agree not to post false listings, impersonate others, use automated tools without permission, scrape data, engage in spam, or participate in any illegal activities on our platform. Violations may result in permanent account termination and legal action.",
    },
    {
        id: 8,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="5" width="20" height="14" rx="2" />
                <line x1="2" y1="10" x2="22" y2="10" />
            </svg>
        ),
        title: "Payments & Subscriptions",
        summary: "All payments are non-refundable unless stated otherwise.",
        content: "Certain services may require payment. All payments are non-refundable unless stated otherwise and are subject to change. Subscription plans renew automatically. You may cancel at any time before the next billing cycle. Pricing changes will be notified in advance.",
    },
    {
        id: 9,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="9" />
                <path d="M15 9a3 3 0 1 0-3 6" />
            </svg>
        ),
        title: "Intellectual Property",
        summary: `All content on ${companyName} is protected by IP laws.`,
        content: `All content, trademarks, logos, and materials on ${companyName} are the property of ${companyName} and protected by intellectual property laws. You may not reproduce, distribute, or create derivative works without our explicit written permission.`,
    },
    {
        id: 10,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="9" />
                <path d="M15 9a3 3 0 1 0-3 6" />
            </svg>
        ),
        title: "Data Privacy",
        summary: `Use of the platform is also governed by our Privacy Policy.`,
        content: <>
        <p>Use of the platform is also governed by our Privacy Policy.</p>
        <p>Users acknowledge that Lead Tracks may collect and process information including:</p>
        <ul>
            <li>Contact Details</li>
            <li>Device Information</li>
            <li>Property Preferences</li>
            <li>Inquiry Records</li>
            <li>Usage Analytics</li>
        </ul>
        <p>By using the platform, users consent to such data processing practices.</p>
        </>,
    },
    {
        id: 11,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10 13a5 5 0 0 1 0-7l1-1a5 5 0 0 1 7 7l-1 1" />
                <path d="M14 11a5 5 0 0 1 0 7l-1 1a5 5 0 1 1-7-7l1-1" />
            </svg>
        ),
        title: "Third-Party Services",
        summary: "Lead Tracks may integrate with third-party services including:",
        content: <>
        <p>Lead Tracks may integrate with third-party services including:</p>
        <ul>
            <li>Google Maps</li>
            <li>Analytics Platforms</li>
            <li>CRM Systems</li>
            <li>Social Media Platforms</li>
        </ul>
        <p>We are not responsible for third-party content, security, or policies.</p>
        <p>Users access third-party services at their own risk.</p>
        </>,
    },
    {
        id: 12,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10 13a5 5 0 0 1 0-7l1-1a5 5 0 0 1 7 7l-1 1" />
                <path d="M14 11a5 5 0 0 1 0 7l-1 1a5 5 0 1 1-7-7l1-1" />
            </svg>
        ),
        title: "Third-Party Content",
        summary: "We are not responsible for third-party content or policies.",
        content: "Our platform may contain third-party content and links. We are not responsible for the content, policies, or practices of third parties. Engaging with third-party services is at your own risk, and we encourage you to review their respective terms and privacy policies.",
    },
    {
        id: 13,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10 13a5 5 0 0 1 0-7l1-1a5 5 0 0 1 7 7l-1 1" />
                <path d="M14 11a5 5 0 0 1 0 7l-1 1a5 5 0 1 1-7-7l1-1" />
            </svg>
        ),
        title: "Disclaimer of Warranties",
        summary: "Lead Tracks provides services on an “as-is” and “as-available” basis.",
        content: <><p>Lead Tracks provides services on an “as-is” and “as-available” basis.</p>
        <p>We do not guarantee:</p>
        <ul>
            <li>Property availability</li>
            <li>Listing accuracy</li>
            <li>Investment returns</li>
            <li>Rental yields</li>
            <li>Lead conversion rates</li>
            <li>Continuous platform availability</li>
            <li>Error-free functionality</li>
        </ul>
        <p>Users should independently verify all information before making decisions.</p>
        </>,
    },
    {
        id: 14,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 3l8 4v5c0 5-3.5 8-8 9-4.5-1-8-4-8-9V7z" />
                <path d="M9 12l2 2 4-4" />
            </svg>
        ),
        title: "Limitation of Liability",
        summary: `To the maximum extent permitted by law, Lead Tracks shall not be liable for:`,
        content: <><p>To the maximum extent permitted by law, Lead Tracks shall not be liable for:</p>
        <ul>
            <li>Financial losses</li>
            <li>Property disputes</li>
            <li>Listing inaccuracies</li>
            <li>Transaction failures</li>
            <li>Broker misconduct</li>
            <li>Business interruption</li>
            <li>Data loss</li>
            <li>Indirect or consequential damages</li>
        </ul>
        <p>Use of the platform is entirely at the user’s own risk.</p>
        </>,
    },
    {
        id: 15,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 12l9-9 9 9" />
                <path d="M9 21V9h6v12" />
            </svg>
        ),
        title: "No Real Estate Guarantee",
        summary: "We do not guarantee property availability or transaction success.",
        content: `We do not guarantee property availability, accuracy, or the success of any real estate transaction. ${companyName} acts solely as an information platform and does not act as a real estate agent or broker. All transactions are between the parties involved.`,
    },
    {
        id: 16,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="5" y="11" width="14" height="10" rx="2" />
                <path d="M8 11V7a4 4 0 0 1 8 0v4" />
            </svg>
        ),
        title: "Privacy",
        summary: "Our Privacy Policy explains how we handle your data.",
        content: `Your use of our platform is also governed by our Privacy Policy, which explains how we collect and use your information. By using ${companyName}, you consent to the data practices described in our Privacy Policy.`,
    },
    {
        id: 17,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="4" y1="20" x2="20" y2="4" />
            </svg>
        ),
        title: "Suspension & Termination",
        summary: "We may suspend access for any violation of these Terms.",
        content: "We reserve the right to suspend or terminate your access to our platform at any time for any violation of these Terms. Upon termination, your right to use the platform ceases immediately and any outstanding obligations remain enforceable.",
    },
    {
        id: 18,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.1 2.1 0 1 1 3 3L7 19l-4 1 1-4z" />
            </svg>
        ),
        title: "Modifications",
        summary: "Continued use means you accept any revised Terms.",
        content: `${companyName} may update these Terms at any time. Continued use of the platform means you accept the revised Terms. We will notify users of significant changes via email or a prominent notice on our website.`,
    },
    {
        id: 19,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.1 2.1 0 1 1 3 3L7 19l-4 1 1-4z" />
            </svg>
        ),
        title: "Changes to Terms",
        summary: "We reserve the right to update these Terms at any time.",
        content:<>
        <p>We reserve the right to update these Terms at any time.</p>
            <p>Updated versions will be posted on this page with revised dates.</p>
            <p>Continued use of the platform after updates constitutes acceptance of revised Terms.</p>
            </>,
    },
    {
        id: 20,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.1 2.1 0 1 1 3 3L7 19l-4 1 1-4z" />
            </svg>
        ),
        title: "Platform Availability",
        summary: "We strive to maintain uninterrupted services but do not guarantee continuous availability.",
        content:<>
        <p>We strive to maintain uninterrupted services but do not guarantee continuous availability
            </p>
            <p>Services may be interrupted due to:</p>
            <ul>
                <li>Maintenance</li>
                <li>Technical failures</li>
                <li>Security incidents</li>
                <li>Third-party outages</li>
                <li>System upgrades</li>
            </ul>
            <p>Lead Tracks shall not be liable for service interruptions.</p>
            </>,
    },
    {
        id: 21,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.1 2.1 0 1 1 3 3L7 19l-4 1 1-4z" />
            </svg>
        ),
        title: "Modifications",
        summary: "Continued use means you accept any revised Terms.",
        content: `${companyName} may update these Terms at any time. Continued use of the platform means you accept the revised Terms. We will notify users of significant changes via email or a prominent notice on our website.`,
    },
    {
        id: 22,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#ff6b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4 2h3a2 2 0 0 1 2 1.7l.5 3a2 2 0 0 1-.5 1.7l-1.3 1.3a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 1.7-.5l3 .5A2 2 0 0 1 22 16.9z" />
            </svg>
        ),
        title: "Contact Information",
        summary: "Reach us via the contact details provided below.",
        content: (
            <>
                For any questions regarding these Terms, please contact us using the details provided below.
                <p>Connecting buyers, sellers, investors, and real estate professionals through a modern platform built for smarter property decisions.</p>
                <ul>
                    <li>
                        <b>Phone: </b>+971 50 361 5200
                    </li>
                    <li>
                        <b>Email: </b>info@leadtracks.ai
                    </li>
                    <li>
                        <b>Address: </b>5th floor office no 510, Opal Tower, Business Bay Dubai, UAE
                    </li>
                </ul>
            </>
        ),
    },
];

export default function TermsOfUse() {
    const [openSection, setOpenSection] = useState(null);

    const toggle = (id) => setOpenSection(openSection === id ? null : id);

    return (
        <div className={styles.page}>
            {/* Hero Banner */}
            <section className={styles.hero}>
                <div className="container">
                    <div className={styles.heroContent}>
                        <div className={styles.breadcrumb}>
                            <span>Home</span>
                            <span className={styles.chevron}>›</span>
                            <span className={styles.breadActive}>Terms of Use</span>
                        </div>
                        <h1 className={styles.heroTitle}>
                            Terms of <span className={styles.heroTitleOrange}>Use</span>
                        </h1>
                        <p className={styles.heroSubtitle}>Please read these terms carefully before using our platform and services.</p>
                        {/* <div className={styles.heroDate}>
                        <span className={styles.calIcon}>📅</span>
                        <span>Last Updated: May 2026</span>
                    </div> */}
                    </div>
                </div>
            </section>

            {/* Main Content */}
            <main className={styles.main}>
                <div className="container">
                    <div className={styles.main_title}>
                        <p>
                            Welcome to {companyName} (“{companyName}”, “we”, “our”, or “us”). These Terms of Use govern your access to and use of our website, mobile applications, digital services, property listing platform, marketing solutions, communication tools, and related real estate services.
                        </p>
                        <p>By accessing or using {companyName}, you agree to comply with and be legally bound by these Terms. If you do not agree with any part of these Terms, you should discontinue use of the platform immediately.</p>
                    </div>
                    <div className={styles.main_row}>
                        <aside className={styles.sidebar}>
                            <div className={styles.sidebarBox}>
                                <h3 className={styles.sidebarTitle}>On this page</h3>
                                <ul className={styles.sidebarList}>
                                    {SECTIONS.map((s) => (
                                        <li key={s.id} className={styles.sidebarItem}>
                                            <button
                                                onClick={() => {
                                                    toggle(s.id);
                                                    document.getElementById(`section-${s.id}`)?.scrollIntoView({ behavior: "smooth", block: "center" });
                                                }}
                                                className={`${styles.sidebarBtn} ${openSection === s.id ? styles.sidebarBtnActive : ""}`}
                                            >
                                                <span className={styles.sidebarNum}>{String(s.id).padStart(2, "0")}.</span>
                                                <span>{s.title}</span>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </aside>
                        <div className={styles.accordion}>
                            {SECTIONS.map((s) => (
                                <div key={s.id} id={`section-${s.id}`} className={`${styles.accordionItem} ${openSection === s.id ? styles.accordionOpen : ""}`}>
                                    <button className={styles.accordionHeader} onClick={() => toggle(s.id)}>
                                        <div className={styles.accordionLeft}>
                                            <span className={styles.accordionIcon}>{s.icon}</span>
                                            <div>
                                                <h2 className={styles.accordionTitle}>
                                                    {s.id}. {s.title}
                                                </h2>
                                                {openSection !== s.id && <p className={styles.accordionSummary}>{s.summary}</p>}
                                            </div>
                                        </div>
                                        <span className={`${styles.chevronIcon} ${openSection === s.id ? styles.chevronUp : ""}`}>
                                            {openSection === s.id ? (
                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="18 15 12 9 6 15" />,
                                                </svg>
                                            ) : (
                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="6 9 12 15 18 9" />,
                                                </svg>
                                            )}
                                        </span>
                                    </button>
                                    {openSection === s.id && (
                                        <div className={styles.accordionBody}>
                                            <div>{s.content}</div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </main>
            <Features />
        </div>
    );
}
